// MonthlySchecule.jsx
import React, { useEffect, useState , useContext, useRef , useMemo } from 'react';
import {
  Box,
  Chip,
  Grid,
  Paper,
  Typography,
  useTheme,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,DialogContentText, DialogActions,
  TextField,
  Button,
  Tooltip,
  Fab,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Divider,
  Autocomplete, CircularProgress
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon,GetApp as DownloadIcon,} from '@mui/icons-material';
import EmailIcon from '@mui/icons-material/Email';
import CheckIcon from '@mui/icons-material/Check';
import InputAdornment from '@mui/material/InputAdornment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { LocalizationProvider, DateTimePicker, TimePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import itLocale from 'date-fns/locale/it';
import { withTranslation } from 'react-i18next';
import { cicassService , auth} from "../../../_services";
import EventMobileCard from './EventMobileCard';
import TokenContext from "components/TokenContext";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { config } from "_helpers";
import CalendarButton from "../../../components/common/CalendarButton";

// Giorni della settimana in italiano, ordine da Lun a Dom
const daysOfWeek = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];
const apiUrl = 'sportivi';
const apiTruckUrl = "anatruck";


const MonthlySportivi = ({ year, month, t , targetEventId, onEventAutoOpened}) => {
  
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentEvent, setCurrentEvent] = useState({
    id: -1,
    start: new Date(),
    end: new Date(),
    title: '',
    // color field hidden
    ritrovo: new Date(),
    luogo: '',
    mezzoId: null,
    squadraAppiedata: 0,
    autistaId: null,
    volontario1Id: null,
    volontario2Id: null,
    note: '',
    inizioTurno: null, 
    fineTurno: null
  });
  const [mode, setMode] = useState('create');
  const [usersList, setUsersList] = useState([]);
  const [mezziList, setMezziList] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingEvent, setDeletingEvent] = useState(null);
  const myRole = auth.getUserRole();
  const { jwt } = useContext(TokenContext);
  const currentUserId = auth.getUserId(jwt);
  const canEdit = ["Admin","SuperUser","Manager"].includes(myRole);
  const [mobileCardOpen, setMobileCardOpen] = useState(false);
  const [mobileCardData, setMobileCardData] = useState(null);
  const [mailSent, setMailSent] = useState(false);
  const toastRef = useRef(null);
  const [toastInfo, setToastInfo] = useState({
    title: '',
    content: '',
    cssClass: '',
    icon: ''
  });
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(currentEvent.luogo)}`;
  const [isMobile, setIsMobile] = useState(window.innerWidth < config.mobileSizeCheck);

  // ──────── Cessione turno: state + helper ────────
  const [swapDialogOpen, setSwapDialogOpen] = useState(false);
  const [swapTarget, setSwapTarget] = useState(null); // { shiftId, ruolo, subject, main }

  const getMyRole = (ev) => {
    if (!ev) return null;
    if (Number(ev.autistaId) === Number(currentUserId)) return "Autista";
    if (Number(ev.volontario1Id) === Number(currentUserId)) return "Volontario 1";
    if (Number(ev.volontario2Id) === Number(currentUserId)) return "Volontario 2";
    return null;
  };

  const isSwapActive = (ev) => !!ev.swapMessageId;

  // Calcolo dei vincoli temporali
  const { canStart, canEnd } = useMemo(() => {
    const now = new Date();
    const ritrovo = new Date(currentEvent.ritrovo);
    const inizio = currentEvent.inizioTurno ? new Date(currentEvent.inizioTurno) : null;
    
    // 1. Inizio: Attivo da 15 min prima del ritrovo, se non già registrato
    const canStart = !currentEvent.inizioTurno && now >= new Date(currentEvent.start);
    // 2. Fine: Attivo se inizio registrato + almeno 30 minuti passati
    const canEnd = currentEvent.inizioTurno && 
                   !currentEvent.fineTurno && 
                   (now >= new Date(inizio.getTime() + 30 * 60000));

    return { canStart, canEnd };
  }, [currentEvent]);
  
  const showToastInfo = (type, message) => {
    let info = { title: '', content: message, cssClass: '', icon: '' };
    switch (type) {
      case 'Success':
        info.title = t('addToastOK');
        info.cssClass = 'e-toast-success';
        info.icon = 'e-success toast-icons';
        break;
      case 'Information':
        info.title = t('editToastOK');
        info.cssClass = 'e-toast-info';
        info.icon = 'e-info toast-icons';
        break;
      case 'Warning':
        info.title = t('deleteToastOK');
        info.cssClass = 'e-toast-warning';
        info.icon = 'e-warning toast-icons';
        break;
      case 'Error':
        info.title = 'Error';
        info.cssClass = 'e-toast-danger';
        info.icon = 'e-error toast-icons';
        break;
      default:
        break;
    }
    setToastInfo(info);
    toastRef.current.show();
  };

  const handleSendMail = async () => {
    try {
      await cicassService.getAll(`${apiUrl}/sendMail/${currentEvent.id}`);
      showToastInfo('Information','Email accodata per invio');
      setMailSent(true);
    } catch (e) {
      showToastInfo('Error', `M: ${e.message}`);
    }
  };

  const handleExportExcel = async () => {
    setIsLoading(true);
    const sendData = ""; 
    await cicassService
     .downloadFilePost(
          apiUrl + "/download/" + currentEvent.id,
          sendData,
          "XLSX"
        );
    setIsLoading(false);
  };

  const formatLocal = date => {
    const pad = n => n.toString().padStart(2, '0');
    return (
      date.getFullYear().toString() +
      pad(date.getMonth() + 1) +
      pad(date.getDate()) +
      pad(date.getHours()) +
      pad(date.getMinutes())
    );
  };
  const formatLocalDateTime = date => {
    const pad = n => String(n).padStart(2, '0');
    return (
      date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds())
    );
  };
  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < config.mobileSizeCheck);
    };
    window.addEventListener('resize', onResize);
    // cleanup
    return () => window.removeEventListener('resize', onResize);
  }, []);
  
  useEffect(() => {
    if (!openDialog && !mobileCardOpen) return;
    const from = formatLocal(currentEvent.start);
    const to   = formatLocal(currentEvent.end);
      cicassService.getAll(`${apiUrl}/users/${currentEvent.id}/${from}/${to}`)
        .then(res => {
          setUsersList(res.data);
        })
        .catch(console.error);
  }, [openDialog,mobileCardOpen, currentEvent.start, currentEvent.end]);
 
 useEffect(() => {
  const init = async () => {
    setIsLoading(true);
    try {
      const [eventsRes, trucksRes] = await Promise.all([
        cicassService.getAll(`${apiUrl}/${year}/${month + 1}`),
        cicassService.getAll(`${apiTruckUrl}`)
      ]);

      const payload = Array.isArray(eventsRes) ? eventsRes : eventsRes.data;
      const mappedEvents = payload.map(ev => ({
        ...ev,
        start: new Date(ev.start),
        end:   new Date(ev.end),
        ritrovo: ev.ritrovo ? new Date(`${new Date(ev.start).toISOString().split('T')[0]}T${ev.ritrovo}:00`) : new Date(),
        note: ev.note || '',
        inizioTurno: ev.inizioTurno ? new Date(ev.inizioTurno) : null,
        fineTurno:   ev.fineTurno   ? new Date(ev.fineTurno)   : null,
      }));

      setEvents(mappedEvents);
      setMezziList(trucksRes.data);

      if (targetEventId) {
        const eventToOpen = mappedEvents.find(e => String(e.id) === String(targetEventId));
        if (eventToOpen) {
          handleOpen(eventToOpen.start, eventToOpen);
          if (onEventAutoOpened) onEventAutoOpened();
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false); // ← garantito, aspetta davvero il completamento
    }
  };
  init();
}, [year, month]); // ← targetEventId separato come in MonthlyShift
  
  useEffect(() => {
    if (mode === 'edit') {
      setMailSent(!!currentEvent.mailSent);
    }
    else if (mode === 'create') {
      setMailSent(false); // Reset per nuovi eventi
    }
  }, [mode, currentEvent.mailSent]);



const autistiOptions = currentEvent.squadraAppiedata === 1
  ? usersList.filter(u => u.id !== currentEvent.volontario1Id && u.id !== currentEvent.volontario2Id)
  : usersList.filter(u => u.isAutista === 1).filter(u => u.id !== currentEvent.volontario1Id && u.id !== currentEvent.volontario2Id);

  const volontari1Options = usersList
    .filter(u => u.id !== currentEvent.autistaId && u.id !== currentEvent.volontario2Id);

  const volontari2Options = usersList
    .filter(u => u.id !== currentEvent.autistaId && u.id !== currentEvent.volontario1Id);
    
  const firstDay = new Date(year, month, 1);
  const startDay = (firstDay.getDay() + 6) % 7;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const weeks = [];
  for (let w = 0, d = 1; w < 6; w++) {
    const week = [];
    for (let i = 0; i < 7; i++) {
      if ((w === 0 && i < startDay) || d > daysInMonth) week.push(null);
      else week.push(d++);
    }
    weeks.push(week);
  }
  const eventsByDate = {};
  events.forEach(ev => {
    const key = ev.start.toDateString();
    (eventsByDate[key] ||= []).push(ev);
  });

  // Validazioni
  const invalidTime = currentEvent.end <= currentEvent.start;
  const invalidRitrovo = currentEvent.ritrovo >= currentEvent.start;
  const saveDisabled = invalidTime || invalidRitrovo || !currentEvent.titolo || !currentEvent.luogo || !currentEvent.mezzoId ;

  // Capitalizza primo carattere weekday
  const weekday = currentEvent.start.toLocaleDateString('it-IT', { weekday: 'long' });
  const weekdayCap = weekday.charAt(0).toUpperCase() + weekday.slice(1);


  const handleOpen = async (date, ev) => {
        if (!canEdit) {
            // sola lettura: prima carico gli utenti in quel turno
            if(ev == undefined) return;
            const from = formatLocal(ev.start);
            const to   = formatLocal(ev.end);
            try {
              const res = await cicassService.getAll(`${apiUrl}/users/${ev.id}/${from}/${to}`);
              const list = res.data;
              // ora ho nomi, posso popolare
              const mezzoName      = mezziList.find(m => m.id === ev.mezzoId)?.name || '-';
              const autistaName    = list.find(u => u.id === ev.autistaId)?.name || '-';
              const volontario1Name= list.find(u => u.id === ev.volontario1Id)?.name || '-';
              const volontario2Name= list.find(u => u.id === ev.volontario2Id)?.name || '-';
              setMobileCardData({ ...ev, mezzoName, autistaName, volontario1Name, volontario2Name , 
                isAutista: Number(ev.autistaId) === Number(currentUserId),
                onRegistraOrario: (campo) => handleRegistraOrario(campo, ev.id),
                myRole: getMyRole(ev),
                hasActiveSwap: isSwapActive(ev),
                currentUserId: currentUserId
              });
              setMobileCardOpen(true);
            } catch (err) {
              console.error("errore fetch utenti per sola lettura", err);
            }
            return;
          }
    
    if (ev) {
      setMode('edit');
      setCurrentEvent(ev);
    } else {
      const s = new Date(date); s.setHours(9,0);
      const e = new Date(s); e.setHours(s.getHours()+1);
      const r = new Date(s.getTime() - 30 * 60000);
      setMode('create');
      setMailSent(false);
      setCurrentEvent({ id: -1, start: s, end: e, title: '', ritrovo: r, luogo: '', mezzoId: null, autistaId: null, volontario1Id: null, volontario2Id: null, squadraAppiedata: 0, note: '' });
    }
    setOpenDialog(true);
  };
  const handleClose = () => setOpenDialog(false);
  
  const handleSave = async () => {
    // prepariamo il payload (trasformiamo le date in stringhe ISO)
    const payload = {
      id: currentEvent.id ?? -1,
      titolo: currentEvent.titolo,
      luogo: currentEvent.luogo,
      start: formatLocalDateTime(currentEvent.start),
      end:   formatLocalDateTime(currentEvent.end),
      ritrovo: currentEvent.ritrovo.toTimeString().slice(0,5), // “HH:mm”
      mezzoId: currentEvent.mezzoId,
      squadraAppiedata: currentEvent.squadraAppiedata,
      autistaId: currentEvent.autistaId || 0,
      volontario1Id: currentEvent.volontario1Id || 0,
      volontario2Id: currentEvent.volontario2Id || 0,
      note: currentEvent.note,
      anaAgencyId: auth.getAgencyId(),   // se serve
      deletedAt: null,
      inizioTurno: currentEvent.inizioTurno ? formatLocalDateTime(currentEvent.inizioTurno) : null,
      fineTurno:   currentEvent.fineTurno   ? formatLocalDateTime(currentEvent.fineTurno)   : null,
    };
  
    try {
      const res = await cicassService.saveOp(apiUrl, payload);
  
      // res.data contiene l'oggetto salvato dal server
      const ev = {
        ...res.data,
        start: new Date(res.data.start),
        end:   new Date(res.data.end),
        ritrovo: res.data.ritrovo ? new Date(`2025-01-01T${res.data.ritrovo}:00`) : new Date(),
        note: res.data.note || ''
      };
  
      setEvents(prev =>
        payload.id === -1
          ? [...prev, ev]
          : prev.map(x => x.id === ev.id ? ev : x)
      );
      
      cicassService.getAll(`${apiUrl}/${year}/${month + 1}`)
        .then(res => {
          const payload = Array.isArray(res) ? res : res.data;
          const mappedEvents = payload.map(ev => ({
            ...ev,
            start: new Date(ev.start),
            end:   new Date(ev.end),
            ritrovo: ev.ritrovo ? new Date(`${new Date(ev.start).toISOString().split('T')[0]}T${ev.ritrovo}:00`) : new Date(),
            note: ev.note || '',
            inizioTurno: ev.inizioTurno ? new Date(ev.inizioTurno) : null,
            fineTurno:   ev.fineTurno   ? new Date(ev.fineTurno)   : null,
          }));

      setEvents(mappedEvents);});
      showToastInfo('Success','Salvataggio avvenuto con successo');
      setOpenDialog(false);
    } catch (error) {
      showToastInfo('Error', `I: ${error.message}`);
    }
  };
  const handleDeleteConfirmed = async () => {
    try {
      await cicassService.deleteOp(apiUrl, deletingEvent.id);
      // aggiorna la lista rimuovendo l'evento cancellato
      setEvents(prev => prev.filter(ev => ev.id !== deletingEvent.id));
      setDeleteDialogOpen(false);
      setDeletingEvent(null);
      setOpenDialog(false);  // chiudi anche il form di modifica
      showToastInfo('Warning','Eliminazione avvenuta con successo');
    } catch (err) {
      showToastInfo('Error', `D: ${err.message}`);
    }
  };
  const calendarDescription = [
  `${t('Luogo')}: ${currentEvent.luogo || '-'}`,
  `${t('Orario di Ritrovo')}: ${currentEvent.ritrovo ? currentEvent.ritrovo.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '-'}`,
  `${t('Mezzo')}: ${mezziList.find(m => m.id === currentEvent.mezzoId)?.name || '-'}`,
  `${t('Autista')}: ${usersList.find(u => u.id === currentEvent.autistaId)?.name || '-'}`,
  `${t('Volontario')}: ${usersList.find(u => u.id === currentEvent.volontario1Id)?.name || '-'}`,
  `${t('Volontario 2')}: ${usersList.find(u => u.id === currentEvent.volontario2Id)?.name || '-'}`,
].join('\n');

  const handleRegistraOrario = async (campo, eventId) => {
    
    const payload = {
      id: eventId ?? currentEvent.id,
      campo: campo 
    };

    try {
      setIsLoading(true);
      
      // Chiamata all'API: il server restituisce l'orario effettivo salvato
      // Assicurati che l'API risponda con l'oggetto aggiornato o il valore del campo
      const response = await cicassService.simplePost(`${apiUrl}/setOrarioLoco`, payload);
      
      // Aggiorniamo lo stato locale usando la data restituita dal server
      // Assumiamo che la risposta contenga il nuovo valore nel campo corrispondente
      const eventoAggiornato = response.data;
      const toDate = f => eventoAggiornato[f] ? new Date(eventoAggiornato[f]) : null;
      const patch = {
        ...eventoAggiornato,
        start:       toDate('start'),
        end:         toDate('end'),
        ritrovo:     toDate('ritrovo'),
        inizioTurno: toDate('inizioTurno'),
        fineTurno:   toDate('fineTurno'),
      };

      setCurrentEvent(patch);
      setMobileCardData(prev => prev ? ({ ...prev, ...patch }) : prev);
      setEvents(prevEvents => 
        prevEvents.map(ev => 
          ev.id === (eventId ?? currentEvent.id) ? { ...ev, ...patch } : ev
        )
      );
      showToastInfo('Success', t('Orario registrato correttamente'));
    } catch (err) {
      console.error(err);
      showToastInfo('Error', t('Errore durante la registrazione: ') + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  // ──────── Cessione turno: handler ────────
  const handleOpenSwapDialog = (ev) => {
    const ruolo = getMyRole(ev);
    if (!ruolo) return;

    setSwapTarget({
      shiftId: ev.id,
      ruolo,
      subject: `Cercasi cambio per turno sportivo - ${ev.titolo}`,
      main:
        `🎯 Ruolo: ${ruolo}\n` +
        `📅 Data: ${ev.start.toLocaleDateString('it-IT')}\n` +
        `⏰ Ora: ${ev.start.toLocaleTimeString('it-IT',{hour:'2-digit',minute:'2-digit'})} - ${ev.end.toLocaleTimeString('it-IT',{hour:'2-digit',minute:'2-digit'})}\n` +
        `📍 Luogo: ${ev.luogo}` 
        
    });
    setSwapDialogOpen(true);
  };

  const handleConfirmSwap = async () => {
    if (!swapTarget) return;
    try {
      setIsLoading(true);
      await cicassService.simplePost('board/sportivi', { shiftId: swapTarget.shiftId });

      const res = await cicassService.getAll(`${apiUrl}/${year}/${month + 1}`);
      const payload = Array.isArray(res) ? res : res.data;
      setEvents(payload.map(ev => ({
        ...ev,
        start: new Date(ev.start),
        end:   new Date(ev.end),
        ritrovo: ev.ritrovo ? new Date(`${new Date(ev.start).toISOString().split('T')[0]}T${ev.ritrovo}:00`) : new Date(),
        note: ev.note || '',
        inizioTurno: ev.inizioTurno ? new Date(ev.inizioTurno) : null,
        fineTurno:   ev.fineTurno   ? new Date(ev.fineTurno)   : null,
      })));

      showToastInfo('Success', t('Annuncio pubblicato'));
      setSwapDialogOpen(false);
      setSwapTarget(null);
      setMobileCardOpen(false);
    } catch (err) {
      showToastInfo('Error', `S: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleWithdrawSwap = async (ev) => {
    if (!ev.swapMessageId) return;
    try {
      setIsLoading(true);
      await cicassService.deleteOp('board', ev.swapMessageId);

      const res = await cicassService.getAll(`${apiUrl}/${year}/${month + 1}`);
      const payload = Array.isArray(res) ? res : res.data;
      setEvents(payload.map(ev2 => ({
        ...ev2,
        start: new Date(ev2.start),
        end:   new Date(ev2.end),
        ritrovo: ev2.ritrovo ? new Date(`${new Date(ev2.start).toISOString().split('T')[0]}T${ev2.ritrovo}:00`) : new Date(),
        note: ev2.note || '',
        inizioTurno: ev2.inizioTurno ? new Date(ev2.inizioTurno) : null,
        fineTurno:   ev2.fineTurno   ? new Date(ev2.fineTurno)   : null,
      })));

      showToastInfo('Warning', t('Annuncio ritirato'));
      setMobileCardOpen(false);
    } catch (err) {
      showToastInfo('Error', `D: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={itLocale}>
      <Box sx={{ position: 'relative', p: 2 }}>
      {isLoading && (
        <Box sx={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          bgcolor: 'rgba(255,255,255,0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10,
          borderRadius: 1
        }}>
          <CircularProgress />
        </Box>
      )}
      {canEdit && (
          <Tooltip title={t('Aggiungi Evento')} placement="top">
            <Fab color="primary" sx={{ position: 'fixed', bottom: 80, right: 20, zIndex: 1000 }} onClick={() => handleOpen(new Date(year, month, 1))}>
              <AddIcon />
            </Fab>
          </Tooltip>)
        }
        {!isMobile &&
        <Grid container>
          {daysOfWeek.map((d, i) => (
            <Grid item xs key={i}>
              <Typography
                align="center"
                sx={{ fontWeight: (d === 'Sab' || d === 'Dom') ? 'bold' : 'normal' }}
              >
                {d}
              </Typography>
            </Grid>
          ))}
        </Grid>}
          {isMobile ? (
            <Box sx ={{minWidth: '336px'}}>
                {weeks.flatMap(week => week).map((day, idx) => (
                  day && (
                    <Box key={idx} sx={{ mb: 1, p: 1, border: '1px solid',  borderColor: 'divider',borderRadius: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {day} {new Date(year, month, day).toLocaleDateString('it-IT', { weekday: 'long' })}
                      </Typography>
                      {eventsByDate[new Date(year, month, day).toDateString()]?.map(ev => {
                        const mine = (
                          ev.autistaId === currentUserId ||
                          ev.volontario1Id === currentUserId ||
                          ev.volontario2Id === currentUserId
                        );
                        const bg = mine ? "#ABEBC6" : "#2c5282";
                        const color = mine ? "#2c5282" : "#FFFFFF"; 

                        return (
                          <Box key={ev.id}
                              onClick={e => {
                                e.stopPropagation();
                                handleOpen(new Date(ev.start), ev);
                              }}
                              sx={{
                                mb: 1,
                                p: 1,
                                borderRadius: 1,
                                bgcolor: bg,
                                color: color,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                              '&:hover': {
                                bgcolor: 'action.selected',
                                color: "#2c5282",
                                '& *': {
                                  color: "#2c5282",
                                }
                              },
                              }}
                            >
                            <Typography noWrap sx={{ color: color }}>{ev.start.toLocaleTimeString([], {hour:'2-digit',minute:'2-digit'})} - {ev.titolo}</Typography>
                            <Typography noWrap variant="body2" sx={{ color: color }}>{ev.luogo}</Typography>
                          </Box>
                        );
                      })}

                    </Box>
                  )
                ))}
              </Box>

          ) 
          
          : (
          <Box sx={{ overflowX: 'auto' }}>

            {weeks.map((week, wi) => (
              <Box
                key={wi}
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
                  gap: 1,                  // spacing fra celle
                  mb: 1,                   // margine fra le righe
                }}
              >
                {week.map((day, di) => {
                  const dateObj = day ? new Date(year, month, day) : null;
                  const key = dateObj?.toDateString() || '';
                  return (
                    <Paper
                      key={di}
                      variant="outlined"
                      square
                      onClick={() => dateObj && handleOpen(dateObj)}
                      sx={{
                        minHeight: { xs: 80, sm: 100 },  // più compatto sui telefoni
                        p: 1,
                        bgcolor: dateObj ? 'inherit' : theme.palette.action.hover,
                        cursor: dateObj ? 'pointer' : 'default',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      {day && (
                        <Typography
                          sx={{
                            fontWeight: [0, 6].includes(new Date(year, month, day).getDay())
                              ? 'bold'
                              : 'normal',
                          }}
                        >
                          {day}
                        </Typography>
                      )}
                      {/* sfondi e chip */}
                      {eventsByDate[key]?.map(ev => {
                        const mine = (
                          ev.autistaId === currentUserId ||
                          ev.volontario1Id === currentUserId ||
                          ev.volontario2Id === currentUserId
                        );
                        const bg = mine ? "#ABEBC6" : "#2c5282";
                        const color = mine ? "#2c5282" : "#FFFFFF"; 
                        return (
                          <Box
                            key={ev.id}
                            onClick={e => { e.stopPropagation(); handleOpen(new Date(ev.start), ev); }}
                            sx={{
                              mt: 0.5,
                              p: 1,
                              borderRadius: 1,
                              bgcolor: bg,
                              color: color,
                              cursor: 'pointer',
                              display: 'inline-block',
                              maxWidth: '100%',
                              lineHeight: 1.2,
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                bgcolor: 'action.selected',
                                color: '#2c5282',
                                '& *': {
                                  color: '#2c5282',
                                },
                              },
                            }}
                          >
                            {/* riga 1: titolo */}
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: color }} noWrap>
                              {ev.titolo}
                            </Typography>
                            {/* riga 2: luogo */}
                            <Typography variant="body2" sx={{ color: color }} noWrap>
                              {ev.luogo}
                            </Typography>
                            {/* riga 3: orario */}
                            <Typography variant="body2"  sx={{ color: color }}>
                              {ev.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                            </Typography>
                          </Box>
                        );
                      })}

                    </Paper>
                  );
                })}
              </Box>
            ))}
          </Box>)}
          {openDialog && (
            <Dialog open={openDialog} onClose={handleClose} fullWidth keepMounted={false}>
            <DialogTitle sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            {mode==='create'?t('Aggiungi Evento'):t('Modifica Evento')}
            <CalendarButton
                data={{
                  title: currentEvent.titolo || 'Evento',
                  start: currentEvent.start,
                  end: currentEvent.end,
                  description: calendarDescription,
                  location: currentEvent.luogo || ''
                }}
                filename={`${currentEvent.titolo || 'evento'}.ics`}
                t={t}
                buttonProps={{
                  sx: {
                    color: "#2c5282",
                    "&:hover": {
                      backgroundColor: "#2c5282",
                      color: "#fff",
                    },
                  }
                }}
              />
          </DialogTitle>
          <DialogContent sx={{ display:'flex', flexDirection:'column', gap:2, mt:1, }}>
            <Divider />
            {Number(currentEvent.autistaId) === Number(currentUserId) && (
              <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1, mt: 1 }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
      <Typography variant="subtitle2">{t('Gestione Turno in Loco')}</Typography>
      {!currentEvent.inizioTurno
        ? <Chip label={t('In attesa')} size="small" sx={{ bgcolor: '#e0e0e0', color: '#555' }} />
        : !currentEvent.fineTurno
          ? <Chip label={t('In corso')} size="small" sx={{ bgcolor: '#fff3e0', color: '#e65100' }} />
          : <Chip label={t('Concluso')} size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32' }} />
      }
    </Box>
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Button
        variant="contained"
        size="small"
        disabled={!canStart}
        onClick={() => handleRegistraOrario('inizioTurno')}
        sx={{
          flex: 1,
          bgcolor: currentEvent.inizioTurno ? '#2e7d32' : undefined,
          '&:hover': { bgcolor: currentEvent.inizioTurno ? '#1b5e20' : undefined },
          '&.Mui-disabled': {
            bgcolor: currentEvent.inizioTurno ? '#2e7d32' : undefined,
            color: currentEvent.inizioTurno ? '#fff' : undefined,
            opacity: currentEvent.inizioTurno ? 0.85 : 0.4,
          }
        }}
      >
        {currentEvent.inizioTurno
          ? '▶ ' + new Date(currentEvent.inizioTurno).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
          : t('Inizio Turno')}
      </Button>
      <Button
        variant="contained"
        size="small"
        disabled={!canEnd}
        onClick={() => handleRegistraOrario('fineTurno')}
        sx={{
          flex: 1,
          bgcolor: currentEvent.fineTurno ? '#2e7d32' : '#e65100',
          '&:hover': { bgcolor: currentEvent.fineTurno ? '#1b5e20' : '#bf360c' },
          '&.Mui-disabled': {
            bgcolor: currentEvent.fineTurno ? '#2e7d32' : undefined,
            color: currentEvent.fineTurno ? '#fff' : undefined,
            opacity: currentEvent.fineTurno ? 0.85 : 0.4,
          }
        }}
      >
        {currentEvent.fineTurno
          ? '⏹ ' + new Date(currentEvent.fineTurno).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
          : t('Fine Turno')}
      </Button>
    </Box>
  </Box>
            )}
            <TextField label={t('Servizio o Manifestazione')} value={currentEvent.titolo} onChange={e=>setCurrentEvent(ev=>({...ev,titolo:e.target.value}))} fullWidth />
            <TextField
              label={t('Luogo')}
              value={currentEvent.luogo}
              onChange={e=>setCurrentEvent(ev=>({...ev,luogo:e.target.value}))}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      component="a"
                      href={mapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      edge="end"
                      size="small"
                      title={t('Apri in Maps')}
                    >
                      <LocationOnIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            {/* Inizio e Giorno */}
            <Typography variant="subtitle1" sx={{ mt:1 , fontWeight: 'bold'}}>{weekdayCap}</Typography>
            <DateTimePicker
                  label={t('Inizio')}
                  value={currentEvent.start}
                  onChange={d=>{
                    const newRit = new Date(d.getTime() - 30 * 60000);
                    setCurrentEvent(ev=>({...ev,start:d,ritrovo:newRit}));
                  }}
                  renderInput={params=><TextField {...params} fullWidth error={invalidTime} helperText={invalidTime?'Data iniziale deve precedere quella finale.':''}/>}              
                  minutesStep={15}
                  ampm={false}
                  inputFormat="dd/MM/yyyy HH:mm"
                />

            {/* Fine e Giorno */}
            <DateTimePicker
                  label={t('Fine')}
                  value={currentEvent.end}
                  onChange={d=>setCurrentEvent(ev=>({...ev,end:d}))}
                  renderInput={params=><TextField {...params} fullWidth error={invalidTime} helperText={invalidTime?'Data iniziale deve precedere quella finale.':''}/>}
                  minutesStep={15}
                  ampm={false}
                  inputFormat="dd/MM/yyyy HH:mm"
                />

            {/* Orario di Ritrovo */}
            <TimePicker label={t('Orario di Ritrovo')} value={currentEvent.ritrovo} onChange={d=>setCurrentEvent(ev=>({...ev,ritrovo:d}))} renderInput={params=><TextField {...params} fullWidth error={invalidRitrovo} helperText={invalidRitrovo?t('Orario di ritrovo deve precedere Inizio'):''}/>} minutesStep={15} ampm={false} />

            {/* Mezzo */}
            <Autocomplete
              fullWidth
              options={mezziList}
              getOptionLabel={(option) => option.name || ''}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={mezziList.find((m) => m.id === currentEvent.mezzoId) || null}
              onChange={(_, newValue) =>
                setCurrentEvent((ev) => ({ ...ev, mezzoId: newValue ? newValue.id : null }))
              }
              renderInput={(params) => (
                <TextField {...params} label={t('Mezzo')} />
              )}
            />
            <FormControl fullWidth>
              <InputLabel>Squadra Appiedata</InputLabel>
              <Select
                value={currentEvent.squadraAppiedata}
                label="Squadra Appiedata"
                onChange={(e) =>
                  setCurrentEvent(ev => ({
                    ...ev,
                    squadraAppiedata: Number(e.target.value),
                    autistaId: null   // reset perché cambia la logica
                  }))
                }
              >
                <MenuItem value={0}>No</MenuItem>
                <MenuItem value={1}>Sì</MenuItem>
              </Select>
            </FormControl>      
            {/* Autista o Volontario*/}
            <Autocomplete
                clearOnEscape
                fullWidth
                options={autistiOptions}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={option => option.name}
                value={autistiOptions.find(u => u.id === currentEvent.autistaId) || null}
                onChange={(_, newValue) =>
                  setCurrentEvent(ev => ({ ...ev, autistaId: newValue?.id || null }))
                }
                renderInput={params => (
                  <TextField {...params} label={currentEvent.squadraAppiedata === 1 ? t('Volontario') : t('Autista')} fullWidth />
                )}
              />

            {/* Volontario 1 */}
            <Autocomplete
                clearOnEscape
                fullWidth
                isOptionEqualToValue={(option, value) => option.id === value.id}
                options={volontari1Options}
                getOptionLabel={option => option.name}
                value={volontari1Options.find(u => u.id === currentEvent.volontario1Id) || null}
                onChange={(_, newValue) =>
                  setCurrentEvent(ev => ({ ...ev, volontario1Id: newValue?.id || null }))
                }
                renderInput={params => (
                  <TextField {...params} label={t('Volontario')} fullWidth />
                )}
              />

            {/* Volontario 2 */}
            <Autocomplete
                fullWidth
                clearOnEscape
                options={volontari2Options}
                getOptionLabel={option => option.name}
                value={volontari2Options.find(u => u.id === currentEvent.volontario2Id) || null}
                onChange={(_, newValue) =>
                  setCurrentEvent(ev => ({ ...ev, volontario2Id: newValue?.id || null }))
                }
                renderInput={params => (
                  <TextField {...params} label={t('Volontario 2')} fullWidth />
                )}
              />
            {/* Note */}
            <TextField label={t('Note')} value={currentEvent.note} onChange={e=>setCurrentEvent(ev=>({...ev,note:e.target.value}))} multiline rows={3} fullWidth />
            {/* Sezione Manager: Editing Manuale Orari */}
            {canEdit && (
              <Box sx={{ my: 2, p: 2, border: '1px dashed grey', borderRadius: 1 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>{t('Editing Amministrativo Orari')}</Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <DateTimePicker
                    label={t("Inizio Turno")}
                    value={currentEvent.inizioTurno}
                    onChange={(newValue) => setCurrentEvent({...currentEvent, inizioTurno: newValue})}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                    ampm={false}
                    inputFormat="dd/MM/yyyy HH:mm"
                  />
                  <DateTimePicker
                    label={t("Fine Turno")}
                    value={currentEvent.fineTurno}
                    onChange={(newValue) => setCurrentEvent({...currentEvent, fineTurno: newValue})}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                    ampm={false}
                    inputFormat="dd/MM/yyyy HH:mm"
                  />
                  <Tooltip title={t("Resetta Orari")}>
                    <IconButton onClick={() => setCurrentEvent(prev => ({...prev, inizioTurno: null, fineTurno: null}))}>
                      <DeleteIcon /> 
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>

            {mode==='edit'&&
              <Box sx={{ display: 'flex', alignItems: 'center', mr: 'auto' , ml: 2}}>
                <IconButton
                  onClick={e => {
                    e.stopPropagation();
                    setDeletingEvent(currentEvent);
                    setDeleteDialogOpen(true);
                  }}
                  color="error"
                >
                  <DeleteIcon/>
                </IconButton>
                {/* send mail */}
                <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    badgeContent={
                      mailSent && (
                        <CheckIcon 
                          sx={{
                            bgcolor: 'green',
                            color: 'white',
                            borderRadius: '50%',
                            fontSize: 12,
                            border: '1px solid white'
                          }}
                        />
                      )
                    }
                  >
                    <IconButton
                        onClick={handleSendMail}
                        title={mailSent ? t('Inviata') : t('Invia Email')}
                >
                  <EmailIcon color="#2c5282" />
                </IconButton>
                  </Badge>
                

                {/* export Excel */}
                <IconButton
                  onClick={handleExportExcel}
                  title={t('Scarica Excel')}
                >
                  <DownloadIcon />
                </IconButton>
              </Box>
            }
            <Button onClick={handleClose}>{t('Annulla')}</Button>
            <Button onClick={handleSave} variant="contained" disabled={saveDisabled}>{t('Salva')}</Button>
          </DialogActions>
        </Dialog>
          )}
        {/* DELETE */}
        <Dialog
            open={deleteDialogOpen}
            onClose={() => setDeleteDialogOpen(false)}
            fullWidth
            maxWidth="xs"
          >
            <DialogTitle>{t("confirmDelete")}</DialogTitle>
            <DialogActions>
              <Button onClick={() => setDeleteDialogOpen(false)}>
                {t("cancel")}
              </Button>
              <Button
                onClick={handleDeleteConfirmed}
                variant="contained"
                color="primary"
              >
                {t("delete")}
              </Button>
            </DialogActions>
        </Dialog>

        {/* SWAP: dialog di conferma cessione turno */}
        <Dialog open={swapDialogOpen} onClose={() => setSwapDialogOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle>{t('Confermi la creazione del messaggio?')}</DialogTitle>
           <DialogContentText sx={{ ml: 4, color: '#4a5568' }}>
            {t('Sarà pubblicato nella home e visibile a tutti i volontari.')}
          </DialogContentText>
          <DialogContent>
            <Box sx={{ p: 2, bgcolor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 1 }}>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
                {swapTarget?.subject}
              </Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-line', color: '#4a5568' }}>
                {swapTarget?.main}
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSwapDialogOpen(false)}>{t('Annulla')}</Button>
            <Button onClick={handleConfirmSwap} variant="contained" color="primary">
              {t('Conferma')}
            </Button>
          </DialogActions>
        </Dialog>

        <ToastComponent
          ref={toastRef}
          title={toastInfo.title}
          content={toastInfo.content}
          cssClass={toastInfo.cssClass}
          icon={toastInfo.icon}
          position={{ X: 'Right', Y: 'Bottom' }}
        />
        {!canEdit && mobileCardData && (
          <EventMobileCard
            open={mobileCardOpen}
            onClose={() => setMobileCardOpen(false)}
            data={mobileCardData}
            t={t}
            onSwapClick={handleOpenSwapDialog}
            onWithdrawClick={handleWithdrawSwap}
            currentUserId={currentUserId}
          />
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default withTranslation()(MonthlySportivi);